import React, { useEffect, useState } from "react";
import "./WriteAReview.css";
import Header from "../../../../Layout/Header/Header";
import Footer from "../../../../Layout/Footer/Footer";
import Icons from "../../../../../../Config/Images";
import CustomImageComponent from "../../../../CustomComponents/CustomImageComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  createFeedBackRatingReviewAPI,
  getFeebackRatingReviewAPI,
  getFeedbackTypeAPI,
  updateFeedBackRatingReviewAPI,
} from "../../../../../../Store/Action/orderAction";
import { toast } from "react-toastify";

const WriteAReview = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [orderData, setOrderData] = useState([]);
  const [orderItems, setOrderItems] = useState([]);
  const [ratings, setRatings] = useState({});
  const [feedbackMessages, setFeedbackMessages] = useState({});
  const [reviews, setReviews] = useState([]);
  const [feedbackIds, setFeedbackIds] = useState({});
  const [feedbackType, setFeedbackType] = useState([]);

  useEffect(() => {
    setOrderData(location?.state?.orderData);
    setOrderItems(location?.state?.orderItems || []);
  }, [location?.state]);

  useEffect(() => {
    dispatch(
      getFeedbackTypeAPI({}, (result) => {
        setFeedbackType(result);
      })
    );
  }, [dispatch]);

  const handleFeedbackChange = (productId, message) => {
    setFeedbackMessages((prevMessages) => ({
      ...prevMessages,
      [productId]: message,
    }));
  };

  // const order = [];
  const isWastageEnabled = true;

  // Function to handle star click
  const handleStarClick = (productId, rating) => {
    setRatings((prevRatings) => ({
      ...prevRatings,
      [productId]: rating,
    }));
  };

  const handleRatingReviewSubmit = (productId) => {
    const rating = ratings[productId]; // Get rating for this product
    const message = feedbackMessages[productId]; // Get message for this product
    const existingFeedbackId = feedbackIds[productId]; // 👈 check if exists

    // if (!rating || !message) {
    //   toast.error("Rating and review are required.");
    //   return;
    // }
    // Check: At least one should be filled
    if (!rating && !message) {
      toast.error("Please provide a rating or a review before submitting.");
      return;
    }

    if (existingFeedbackId) {
      // ✅ Update feedback
      const updateData = {
        feedback_id: existingFeedbackId,
        feedback_rating: rating,
        feedback_message: message,
        order_id: location.state.orderData.order_id,
      };

      dispatch(
        updateFeedBackRatingReviewAPI(updateData, (result) => {
          if (result?.status) {
            toast.success("Feedback updated successfully!");
            navigate("/my-account/my-orders");
          }
        })
      );
    } else {
      const feedbackTypeForProduct = feedbackType?.find(
        (e) => e?.feedback_type_name?.toLowerCase() === "product"
      );

      const requesData = {
        product_id: productId,
        feedback_type_id: feedbackTypeForProduct?.feedback_type_id,
        feedback_rating: rating,
        feedback_message: message,
        order_id: location.state.orderData.order_id,
      };

      dispatch(
        createFeedBackRatingReviewAPI(requesData, (result) => {
          if (result?.status) {
            toast?.success(result?.message?.message);
            navigate("/my-account/my-orders");
          }
        })
      );
    }
  };

  // useEffect(() => {
  //   dispatch(
  //     getFeebackRatingReviewAPI({}, (result) => {
  //       if (result?.status && result?.data?.data) {
  //         setReviews(result.data.data); // store all reviews
  //       }
  //     })
  //   );
  // }, [dispatch]);

  useEffect(() => {
    const params = {
      order_id: location?.state?.orderData?.order_id,
      feedback_type: "user_feedback",
    };
    dispatch(
      getFeebackRatingReviewAPI(params, (result) => {

        if (result?.status && result?.data) {
          const reviews = result.data;

          setReviews(reviews);

          // ✅ Prefill stars and messages
          const prefillRatings = {};
          const prefillMessages = {};
          const prefillIds = {};

          reviews.forEach((review) => {
            prefillRatings[review.product_id] = review.feedback_rating || 0;
            prefillMessages[review.product_id] = review.feedback_message || "";
            prefillIds[review.product_id] = review.feedback_rating_id;
          });

          setRatings(prefillRatings);
          setFeedbackMessages(prefillMessages);
          setFeedbackIds(prefillIds);
        }
      })
    );
  }, [dispatch]);

  const handleOrderedProductClick = (product) => {

    if (!product?.product_name) return; // Prevents errors if product_name is null/undefined
    // Custom slug creation logic
    const formattedName = product?.product_name
      .toLowerCase() // Convert to lowercase
      .trim() // Trim spaces at the beginning and end
      .replace(/\s+/g, "-") // Replace one or more spaces with a hyphen
      .replace(/[^a-z0-9\-]/g, "") // Remove all non-alphanumeric characters except hyphens
      .replace(/-+/g, "-") // Replace multiple hyphens with a single hyphen
      .replace(/^-+/, "") // Remove any leading hyphens
      .replace(/-+$/, ""); // Remove any trailing hyphens
    navigate(`/productDetail/${formattedName}`, {
      state: { productId: product.product_id },
    });
  };
  return (
    <>
      <Header />
      <div className="write-a-review-main-div">
        <div className="order-account-header-write-a-review">
          <h3>Write a Product Review</h3>
        </div>
        <div className="divider-write-a-review" />

        {orderItems?.map((product, index) => {
          const isProductType =
            product?.product_category_type_name?.toLowerCase() === "product";

          return (
            <div
              key={product?.product_id || index}
              className="products-review-rating-main-div"
            >
              <div className="wrapper-div-write-a-review">
                <div className="ordered-products">
                  <div
                    className="ordered-products-img"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleOrderedProductClick(product)}
                  >
                    <CustomImageComponent src={product?.product_image_url} />
                  </div>

                  <div className="ordered-products-info">
                    <p className="para-highlight">{product?.product_name}</p>

                    {/* ✅ Show ONLY if NOT product */}
                    {isProductType && (
                      <>
                        <div style={{ display: "flex" }}>
                          <p className="write-a-review-para-prod-detail">
                            Net weight
                          </p>
                          <span>: {product?.total_net_weight}</span>
                        </div>

                        <div style={{ display: "flex" }}>
                          <p className="write-a-review-para-prod-detail">
                            Wastage
                          </p>
                          <span>: {product?.product_wastage}</span>
                        </div>

                        <div style={{ display: "flex" }}>
                          <p className="write-a-review-para-prod-detail">
                            Per pcs fine
                          </p>
                          <span>: {product?.total_product_per_pc_fine}</span>
                        </div>
                      </>
                    )}

                    <div style={{ display: "flex" }}>
                      <p className="write-a-review-para-prod-detail">
                        Product Qty
                      </p>
                      <p className="">: {product?.total_quantity}</p>
                    </div>
                    {!isProductType && (
                      <>
                        <div style={{ display: "flex" }}>
                          <p className="write-a-review-para-prod-detail">
                            Per Pc rate
                          </p>
                          <p className="">: {product?.total_per_pc_rate}</p>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                <div className="stars-rating-div">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <img
                      key={star}
                      src={
                        star <= (ratings[product?.product_id] || 0)
                          ? Icons.star_icon
                          : Icons.blank_star_icon
                      }
                      alt=""
                      onClick={() => handleStarClick(product?.product_id, star)}
                      style={{ cursor: "pointer" }}
                    />
                  ))}
                </div>

                <div className="feedback-text-input-div">
                  <textarea
                    className="feedback-textarea"
                    placeholder="Share your own experience with us."
                    value={feedbackMessages[product?.product_id] || ""}
                    onChange={(e) =>
                      handleFeedbackChange(product?.product_id, e.target.value)
                    }
                  />
                </div>

                <div className="submit-btn-div-write-a-review">
                  <button
                    onClick={() =>
                      handleRatingReviewSubmit(product?.product_id)
                    }
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <Footer />
    </>
  );
};

export default WriteAReview;
